// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * RBAC permission verb for per-scope (bank / lift / floor) grants.
 *
 * Used by `RoleBankPermission`, `RoleLiftPermission`, and `RoleFloorPermission`
 * (see user.fbs) to gate what a role may do within one specific scope row.
 *
 * VIEW (0)   — read that scope's configuration AND its live/activity data.
 *              Default verb; value MUST stay 0 so a row written without an
 *              explicit action decodes as VIEW.
 * CREATE (1) — create child entities under that scope.
 * UPDATE (2) — modify that scope's configuration (openings, floors, etc.).
 * DELETE (3) — delete that scope or its children.
 * ACTION (4) — fire Control messages targeting that scope (button presses,
 *              command toggles). Distinct from UPDATE: runtime-command
 *              authority vs config-write authority.
 *
 * Default semantics ("a role with NO permission rows for an entity class has
 * access to ALL entities of that class") are enforced by the consumers
 * (`LiftCloud` + frontend), NOT by this schema. This enum and its tables are
 * pure data carriers.
 */
export enum PermissionAction {
  VIEW = 0,
  CREATE = 1,
  UPDATE = 2,
  DELETE = 3,
  ACTION = 4,
}
